import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import Header from "../../../components/header";
import { RulesState } from "../hooks/use-rules";

type RulesHeaderProps = {
  state: RulesState;
};

const RulesHeader = (props: RulesHeaderProps) => {
  const rulesState: RulesState = props.state;

  return (
    <Header>
      <div className="w-full container mx-auto">
        <div className="container mx-auto text-3xl text-white mb-6 font-semibold">
          Find a Rule
        </div>
        <div className="flex items-center py-2 px-6 container mx-auto rounded-full bg-white gap-2 mb-6">
          <MagnifyingGlassIcon className="h-8 w-8 text-gray-500" />
          <input
            key="search-input"
            className="w-full m-2 outline-none text-lg"
            placeholder="Search Rules"
            value={rulesState.query}
            onChange={(e) => rulesState.setQuery(e.target.value)}
          ></input>
        </div>
      </div>
    </Header>
  );
};

export default RulesHeader;
